module.exports = __webpack_public_path__ + "static/warehouse-4cb474e22fc610bfb644f12f275c8e1f.png";